"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class GetIpsFromSender {
    static getAttributeTypeMap() {
        return GetIpsFromSender.attributeTypeMap;
    }
}
GetIpsFromSender.discriminator = undefined;
GetIpsFromSender.attributeTypeMap = [
    {
        "name": "ips",
        "baseName": "ips",
        "type": "Array<GetIpFromSender>"
    }
];
exports.GetIpsFromSender = GetIpsFromSender;
//# sourceMappingURL=getIpsFromSender.js.map